import React, { useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useHistory, useParams } from 'react-router-dom';
import { Grid, List, ListItem, ListItemText, Divider } from '@material-ui/core';
import { Amount, AppBar, Page, ScreenLoader } from 'components';
import { anketsStore, objectStore } from 'stores';
import { ru } from 'locale';

const ObjectScreen = observer(() => {
  const history = useHistory();
  const { fetchState, object } = objectStore;
  const { objectId } = useParams();

  useEffect(
    () =>
      autorun(() => {
        objectStore.getObject(anketsStore.anketId, objectId);
      }),
    [objectId],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const renderAmount = value => {
    return (
      <Amount
        amount={{
          value,
          currency: { code: 'RUR', minority: 0 },
        }}
      />
    );
  };

  const renderObject = () => {
    return (
      <List aria-label={ru.object}>
        <ListItem>
          <ListItemText primary={ru.name} secondary={object.name} />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary={ru.code} secondary={object.id} />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary={ru.type} secondary={object.type} />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary={ru.address} secondary={object.address} />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary={ru.generalContractor} secondary={object.generalContractor} />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary={ru.revenue} secondary={renderAmount(object.revenue)} />
        </ListItem>
        <Divider />
      </List>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <Grid item>
          <AppBar title={ru.object} onNavButtonClick={handleBackClick} />
        </Grid>
        <Grid>
          {fetchState === 'pending' && <ScreenLoader />}
          {fetchState === 'fulfilled' && renderObject()}
        </Grid>
      </Grid>
    </Page>
  );
});

export default ObjectScreen;
